module.exports = {"370502001":"文汇街道","370502002":"黄河路街道","370502003":"东城街道","370502004":"辛店街道","370502005":"胜利街道","370502006":"胜园街道","370502102":"牛庄镇","370502103":"六户镇","370502104":"史口镇","370502105":"龙居镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370502.json
// module id = 1284
// module chunks = 0